import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import AOS from "aos";
import "aos/dist/aos.css";

const ServiceStyles = styled.section`

    .services__container{
        row-gap: 2.5rem;
        justify-content: center;
    }

    .services__card{
        position: relative;
        width: 230px;
        height: 380px;
        background-color: var(--container-color);
        text-align: center;
        padding: 3.5rem 1.5rem;
        border-radius: 7.25rem;
        transition: background 0.4s;

        i{
            display: block;
            font-size: 2rem;
            color: var(--title-color);
            margin-bottom: .75rem;
            transition: transform .8s;
        }
        &:hover i{
            transform: rotateY(360deg);
        }

        .services__title{
            font-size: var(--h2-font-size);
            font-weight: var(--font-semi-bold);
            margin-bottom: 1.5rem;
        }

        .services__border{
            width: 250px;
            height: 400px;
            border: 1.8px solid var(--text-color-light);
            position: absolute;
            inset: 0;
            left: -10px;
            margin: auto;
            z-index: -1;
            transition: opacity .6s;
            opacity: 0;
            border-radius: 7.75rem;
        }

        &:hover .services__border{
            opacity: 1;
        }
    }
    @media screen and (min-width: 767px){
        .services__container{
            grid-template-columns: repeat(2,max-content);
            column-gap: 5rem;
        }
    }
    @media screen and (min-width: 1048px){
        .container{
            margin-inline: auto;
        }
    }
    @media screen and (min-width: 1200px){
        .services__container{
            grid-template-columns: repeat(3,max-content);
        }
        .services__card{
            width: 250px;
            height: 350px;
            border-radius: 7.6rem;
           padding: 3.5rem 1.5rem;

           i{
            font-size: 2.5rem;
           }
           .services__border{
               width: 270px;
               height: 370px;
               border-radius: 8.25rem;
           }
        }
    }
`


function Services({ menuref }) {

    const currref = useRef(null);

    const scrollActive = () => {
        const scrollY = window.pageYOffset;
        const sectionHeight = currref.current.offsetHeight;
        const sectionTop = currref.current.offsetTop - 58;
        // console.log(currref.current.id);
        const sectionId = currref.current.id;
        const sectionClass = menuref.current.querySelector('.nav__menu a[href*=' + sectionId + ']');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionClass.classList.add('active-link');
        } else {
            sectionClass.classList.remove('active-link');
        }

    }
    useEffect(() => {
        AOS.init({
            duration: 500,
        });
        AOS.refresh();

        window.addEventListener("scroll", scrollActive);
    }, [])
    return (
        <ServiceStyles className='section' id='services' ref={currref}>
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What i offer</span>

            <div className="services__container container grid section__border">
                <div className="services__card" data-aos="fade-up-right">
                    <i className="ri-layout-4-line"></i>
                    <h2 className="services__title">
                        UI/UX Design
                    </h2>
                    <p className="services__description">
                        Development of fully responsive web applications with good User interface and experience. Manage the responsiveness and update UI of the application as per the changes required from time to time.
                    </p>

                    <div className="services__border"></div>
                </div>


                <div className="services__card" data-aos="fade-down">
                    <i className="ri-code-fill"></i>
                    <h2 className="services__title">
                        end to end Development
                    </h2>
                    <p className="services__description">
                        Creating servers and databases for backend, Developing APIs and RESTful services and integrate them with frontend and deployment of application altogether.
                    </p>

                    <div className="services__border"></div>
                </div>


                <div className="services__card" data-aos="fade-up-left">
                    <i className="ri-user-star-fill"></i>
                    <h2 className="services__title">
                        Professionlism
                    </h2>
                    <p className="services__description">
                        Good with working with people, an Enthusiast and assertive speaker, Time management skills to accomplish things effectively. Quick to learn and adapt.
                    </p>

                    <div className="services__border"></div>
                </div>


            </div>

        </ServiceStyles>
    )
}

export default Services